/**
 * PUBLIC_STARTUP_FAILURE
 */
function * initializeAppFailure ({ error }) {
  // @todo
  console.log('initializeAppFailure', error)
}

export default initializeAppFailure
